import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {isMobile, isTablet} from "../helpers";


export function scrollImageSection() {
    if (!$('.scroll-change-img').length) return;

    gsap.registerPlugin(ScrollTrigger);

    // let panels = gsap.utils.toArray('.scroll-item');
    //
    // panels.forEach((panel, i) => {
    //     ScrollTrigger.create({
    //         scroller: isMobile() || isTablet() ? '' : '.scroller',
    //         trigger: panel,
    //         start: 'top top',
    //         pin: i !== panels.length - 1,
    //         pinSpacing: false
    //     });
    // });
    //
    // gsap.set('.scroll-item', {zIndex: (i, target, targets) => targets.length - i});

    gsap.utils.toArray(".scroll-item").forEach((section, i) => {

        if (!isMobile()) {
            // Do the parallax effect on each section
            if (i) {
                section.style.backgroundPosition = `50% ${-innerHeight / 2}px`;

                gsap.to(section, {
                    backgroundPosition: `50% ${innerHeight / 2}px`,
                    ease: "none",
                    scrollTrigger: {
                        scroller: isMobile() || isTablet() ? '' : '.scroller',
                        trigger: section,
                        scrub: true
                    }
                });
            }

            // the first image should be positioned against the top. Use px on the animating part to work with GSAP.
            else {
                section.style.backgroundPosition = "50% 0px";

                gsap.to(section, {
                    backgroundPosition: `50% ${innerHeight / 2}px`,
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        scroller: isMobile() || isTablet() ? '' : '.scroller',
                        start: "top top",
                        end: "bottom top",
                        scrub: true
                    }
                });
            }
        } else {
            section.style.backgroundPosition = "50% 0px";

            gsap.to(section, {
                backgroundPosition: `50% ${innerHeight / 7}px`,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        }
    });
}
